import React, { useEffect } from "react";
import "./PortfolioModal.css";

function getGifForCompany(companyName = "") {
  const c = String(companyName).toLowerCase();

  if (c.includes("ups")) return "images/ups.webp";
  if (c.includes("costar")) return "images/costar.gif";
  if (c.includes("chick")) return "images/cfa.gif";
  if (c.includes("cargill")) return "images/cargill.gif";
  if (c.includes("bmw")) return "images/bmw.gif";
  if (c.includes("upwork") || c.includes("freelance")) return "images/ruby.gif";

  return null;
}

export default function PortfolioModal({ isOpen, onRequestClose, content = {} }) {
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onRequestClose?.();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onRequestClose]);

  if (!isOpen) return null;

  const gif = getGifForCompany(content.company_name);
  const gifSrc = gif ? `${process.env.PUBLIC_URL}/${gif}` : null;

  const logoSrc = content.imageUrl ? `${process.env.PUBLIC_URL}/${content.imageUrl}` : null;

  const titleNode = content.title ?? content.titleText ?? "";
  const descNode = content.description ?? content.descriptionText ?? "";
  const tech = Array.isArray(content.tech_stack) ? content.tech_stack : [];

  const onOverlayMouseDown = (e) => {
    if (e.target === e.currentTarget) onRequestClose?.();
  };

  return (
    <div className="portfolio-modal-overlay" onMouseDown={onOverlayMouseDown}>
      <div className="portfolio-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <button type="button" className="modal-close" onClick={onRequestClose} aria-label="Close">
            ×
          </button>

          {gifSrc && (
            <img
              className="modal-company-gif"
              src={gifSrc}
              alt=""
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          )}

          <div className="modal-title-area">
            <h3 className="modal-title">{titleNode}</h3>

            <div className="modal-subtitle">
              {content.company_name && <span className="modal-company">{content.company_name}</span>}
              {content.date && <span className="modal-date">{content.date}</span>}
            </div>

                    {logoSrc && (
          <div style={{ padding: "12px 16px 0" }}>
            <img
              src={logoSrc}
              alt={`${content.company_name || "Company"} logo`}
              style={{ width: "160px", height: "auto", objectFit: "contain", display: "block" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        )}
          </div>
        </div>

        {tech.length > 0 && (
          <div className="modal-tech">
            {tech.map((t) => (
              <span key={t} className="tech-chip">
                {t}
              </span>
            ))}
          </div>
        )}

        <div className="modal-body">
          <p className="modal-description">{descNode}</p>
        </div>
      </div>
    </div>
  );
}
